var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUncertain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7,
    fill: "#D1C409"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12459 9.959V10.4098H7.47819V9.9884C7.47819 8.3812 9.27159 8.4008 9.34019 7.46C9.37939 6.8622 8.91879 6.725 8.32099 6.725C7.78199 6.725 7.03719 6.921 7.03719 6.921L6.89999 5.7744C6.89999 5.7744 7.86039 5.5 8.55619 5.5C10.036 5.5 11.0552 6.1958 10.9964 7.4404C10.9082 9.2632 9.12459 9.1652 9.12459 9.959ZM8.28179 12.5168C7.84079 12.5168 7.47819 12.1738 7.47819 11.7524C7.47819 11.331 7.84079 10.988 8.28179 10.988C8.73259 10.988 9.08539 11.331 9.08539 11.7524C9.08539 12.1738 8.73259 12.5168 8.28179 12.5168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUncertain);
export default __webpack_public_path__ + "static/media/icon-uncertain.8e9ee2c3225419fad80c2acdce567f6a.svg";
export { ForwardRef as ReactComponent };